<template>
  <div>
    <div class="file-area frame-dashed">
      <input
        :id="`file-${id}`"
        type="file"
        class="upload-file"
        accept="image/png, image/jpeg"
        v-on:change="fileSelected"
        :name="name"
      />
      <div class="file-thumb-area"></div>
      <p class="small pc">
        画像（JPG，PNG）を
        <span>ドラッグ＆ドロップしてください 。</span>
        <br />または
      </p>
      <label class="btn btn-file" :for="`file-${id}`">ファイルを選択</label>
      <div class="small upload-filename">ファイルが選択されていません</div>
    </div>
    <ul class="list-unstyled notes">
      <li>※ 3MB以内の画像ファイルを用意してください。</li>
      <li>※ JPGおよびPNGの画像ファイルに対応しています。</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FileUpload",
  props: {
    name: {
      type: String,
      default: "",
    },
  },
  emits: ["file-selected"],
  data() {
    return {
      id: this.randomString(),
    };
  },
  methods: {
    fileSelected(event) {
      this.$emit("file-selected", event.target.files[0]);
    },
  },
};
</script>
